module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colla', {
    staticClass: "collapp-li",
    attrs: {
      "transition": "slide"
    }
  }, [_c('colla', {
    staticClass: "collapp-profile"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('colla', {
    staticClass: "collapp-msg"
  }, [_c('colla', {
    staticClass: "collapp-msg-body"
  }, [_c('p', {
    staticClass: "collapp-name"
  }, [_vm._v(_vm._s(_vm.comment.name) + " "), _c('colla', {
    staticClass: "collapp-date"
  }, [_vm._v(_vm._s(_vm.time))])], 1), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.comment.message)
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77a4aede!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Comment.vue
// module id = 26
// module chunks = 0